import Vue from 'vue'
import axios from '@/plugins/axios'
import { normalizeBrazilPhone } from '@/utils/campaignPhones'

export const findById = async (_, id) => {
  try {
    const { data } = await axios.get(`whatsapp-campaign/${id}`)

    return data
  } catch (err) {
    return err
  }
}

export const findAll = async (_, params = {}) => {
  try {
    const { data } = await axios.get('whatsapp-campaign', { params })

    return data || []
  } catch (err) {
    console.error('Erro ao buscar campanhas WhatsApp:', err)
    return []
  }
}

export const findWhatsappTemplates = async () => {
  try {
    const response = await axios.get('whatsapp-templates')

    return response.data
  } catch (err) {
    console.error('Erro ao buscar templates WhatsApp:', err)
    return null
  }
}

export const findAllChannelRequests = async (_, params = {}) => {
  try {
    const { data } = await axios.get('whatsapp-channel-request', { params })

    return data || []
  } catch (err) {
    console.error('Erro ao buscar solicitações de canal WhatsApp:', err)
    return []
  }
}

export const createChannelRequest = async (_, body) => {
  Vue.prototype.$loading(true)

  try {
    const formData = new FormData()
    formData.append('profileName', body.profileName)

    if (body.userId) {
      formData.append('userId', body.userId)
    }

    if (body.profilePhoto) {
      formData.append('profilePhoto', body.profilePhoto)
    }

    const { status } = await axios.post('whatsapp-channel-request', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return status
  } catch (err) {
    console.error('Erro ao criar solicitação de canal WhatsApp:', err)
    if (err.response) {
      console.error('Response error:', err.response.data)
    }
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const approveChannelRequest = async (_, { id, ...body }) => {
  Vue.prototype.$loading(true)
  try {
    await axios.put(`whatsapp-channel-request/approve/${id}`, body)
    return true
  } catch (err) {
    console.error('Erro ao aprovar solicitação de canal:', err)
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const refuseChannelRequest = async (_, { id, ...body }) => {
  Vue.prototype.$loading(true)
  try {
    await axios.put(`whatsapp-channel-request/refuse/${id}`, body)
    return true
  } catch (err) {
    console.error('Erro ao recusar solicitação de canal:', err)
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const create = async (_, body) => {
  Vue.prototype.$loading(true)

  console.error('Body:', body)
  try {

    console.error('Body:', body)
    const formData = new FormData()
    
    // Adicionar campos do formulário
    formData.append('campaignName', body.campaignName)
    formData.append('profileName', body.profileName)
    formData.append('recipientType', body.recipientType)
    formData.append('messageContent', body.messageContent)
    formData.append('scheduleType', body.scheduleType)
    
    // Adicionar arquivos se existirem
    if (body.profilePhoto) {
      console.error('Adicionando profilePhoto ao FormData:', {
        name: body.profilePhoto.name,
        size: body.profilePhoto.size,
        type: body.profilePhoto.type,
        isFile: body.profilePhoto instanceof File
      })
      formData.append('profilePhoto', body.profilePhoto)
    }
    
    if (body.mediaFile) {
      formData.append('mediaFile', body.mediaFile)
    }
    
    // Adicionar campos opcionais
    if (body.buttonLink) {
      formData.append('buttonLink', body.buttonLink)
    }
    
    if (body.buttonName) {
      formData.append('buttonName', body.buttonName)
    }
    
    if (body.scheduledDate) {
      formData.append('scheduledDate', body.scheduledDate)
    }
    
    if (body.anonymizeRecipients !== undefined) {
      formData.append('anonymizeRecipients', body.anonymizeRecipients)
    }

    if (body.channelRequestIds && body.channelRequestIds.length > 0) {
      formData.append('channelRequestIds', JSON.stringify(body.channelRequestIds))
    }

    if (body.useGenericChannel) {
      formData.append('useGenericChannel', true)
    }
    
    // Enviar os telefones em um único campo JSON evita payload multipart gigante
    // Formato com variáveis igual SMS/RCS: [{ NUMERO: '55...', NOME: 'Everton' }]
    if (body.contacts && body.contacts.length > 0) {
      const phoneKeyAliases = new Set([
        'phone',
        'telefone',
        'numero',
        'celular',
        'numero_whatsapp',
        'telefone_limpo',
        'celular_limpo',
        'numero_limpo',
      ])

      const phones = body.contacts.map(contact => {
        if (contact && typeof contact === 'object') {
          const rawPhone =
            contact.NUMERO ||
            contact.numero ||
            contact.phone ||
            contact.telefone ||
            ''
          const numero = normalizeBrazilPhone(rawPhone)

          const variables = {}
          Object.entries(contact).forEach(([key, value]) => {
            const normalizedKey = String(key)
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .trim()
              .replace(/\s+/g, '_')
              .replace(/[^a-zA-Z0-9_]/g, '')
              .toUpperCase()

            if (!normalizedKey || phoneKeyAliases.has(normalizedKey.toLowerCase())) {
              return
            }
            if (value === undefined || value === null || String(value).trim() === '') {
              return
            }
            variables[normalizedKey] = String(value).trim()
          })

          if (Object.keys(variables).length > 0) {
            return { NUMERO: numero, ...variables }
          }

          // Digitar/colar sem variáveis extras: ainda envia objeto com NUMERO
          if (contact.NUMERO || contact.numero) {
            return { NUMERO: numero }
          }

          return numero
        }

        return String(contact || '').replace(/\D/g, '')
      }).filter(item => {
        if (item && typeof item === 'object') {
          return Boolean(item.NUMERO)
        }
        return Boolean(item)
      })

      formData.append('phones', JSON.stringify(phones))
    }

    const { status } = await axios.post('whatsapp-campaign', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return status
  } catch (err) {
    console.error('Erro ao criar campanha WhatsApp:', err)
    if (err.response) {
      console.error('Response error:', err.response.data)
    }
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const finalize = async (_, { campaignId, reportFile, reportFileSent, reportFileUnsent }) => {
  Vue.prototype.$loading(true)
  try {
    const formData = new FormData()
    
    // Adicionar arquivo de relatório se existir
    if (reportFile) {
      formData.append('reportFile', reportFile)
    }

    if (reportFileSent) {
      formData.append('reportFileSent', reportFileSent)
    }

    if (reportFileUnsent) {
      formData.append('reportFileUnsent', reportFileUnsent)
    }
    
    await axios.post(`whatsapp-campaign/${campaignId}/finalize`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return true
  } catch (err) {
    console.error('Erro ao finalizar campanha WhatsApp:', err)
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const cancel = async (_, { campaignId, reportFile, reportFileSent, reportFileUnsent }) => {
  Vue.prototype.$loading(true)
  try {
    const formData = new FormData()
    
    if (reportFile) {
      formData.append('reportFile', reportFile)
    }

    if (reportFileSent) {
      formData.append('reportFileSent', reportFileSent)
    }

    if (reportFileUnsent) {
      formData.append('reportFileUnsent', reportFileUnsent)
    }
    
    await axios.post(`whatsapp-campaign/${campaignId}/cancel`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return true
  } catch (err) {
    console.error('Erro ao cancelar campanha WhatsApp:', err)
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const approve = async (_, { campaignId, scheduledDate }) => {
  Vue.prototype.$loading(true)
  try {
    await axios.post(`whatsapp-campaign/${campaignId}/approve`, {
      scheduledDate,
    })
    return true
  } catch (err) {
    console.error('Erro ao aprovar campanha WhatsApp:', err)
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}
